import { buildCssClassName } from "@/3514/utils"
import AttentionSvg from "@/svgs/AttentionSvg"

export type Props = {
    message: string
    className?: string
    align?: "center" | "start" | "end"
    containerClassname?: string
}
export const WarningMessage = ({ message, className = "", containerClassname = "", align = "center" }: Props) => {
    const alignmentClasses = {
        center: "justify-content-center",
        left: "justify-content-start",
        right: "justify-content-end"
    }

    return message ? (
        <div className={buildCssClassName("form-has-error", containerClassname)}>
            <div className={buildCssClassName("input-error", className, alignmentClasses[align])}>
                <AttentionSvg />
                <span className="d-inline-block">{message}</span>
            </div>
        </div>
    ) : null
}
